// enums.js

export const ActivityTypeDataEnum = {
  CREATE_ORDER: { id: 11, name: "Create Order" },
  SMS_CREATE_ORDER: { id: 12, name: "Sms Create Order" },
  SMS_PICKED_UP: { id: 13, name: "Sms Picked Up" },
  SMS_OUT_FOR_DELIVERY: { id: 14, name: "Sms Out For Delivery" },
  RECHARGE_WALLET: { id: -2, name: "Recharge Wallet" },
  RETURN_TO_ORIGIN: { id: 21, name: "Return To Origin" },
  INSTANT_CREDIT: { id: -1, name: "Instant Credit" },
  INSTANT_DEBIT: { id: 1, name: "Instant Debit" },
  REFUND: { id: 2, name: "Refund" },
  SMS_ORDER_STATUS_UPDATE: { id: 40, name: "SMS On Order Status Update" },
};

export const TransactionStatusEnum = {
  PENDING: { id: 1, name: "Pending" },
  CONFIRMED: { id: 2, name: "Confirmed" },
  VOID: { id: 3, name: "Void" },
  FAILED: { id: 4, name: "Failed" },
};

export const TransactionTypeEnum = {
  DEPOSIT: { id: 1, name: "Deposit" },
  WITHDRAW: { id: 2, name: "Withdraw" },
  REFUND: { id: 3, name: "Refund" },
};

export const OrderBusinessStatusEnum = {
  NO_STATUS_EXIST: { code: "0", name: "No Status Exist For The Order" },
  SHIPMENT_PAYMENT_FAILED_DUE_TO_INSUFFICIENT_BALANCE: { code: "10", name: "Shipment Payment Failed" },
  SHIPMENT_PAYMENT_PROCESSING_FAILED: { code: "20", name: "Shipment Payment Processing Failed" },
  ORDER_PLACED: { code: "30", name: "Order Has Been Placed / Manifested on Carrier Partner" },
  PICKUP_PENDING: { code: "40", name: "Pickup Pending" },
  PICKUP_FAILED: { code: "50", name: "Pickup Failed" },
  PICKED_UP: { code: "60", name: "Pickup Has Been Done" },
  INTRANSIT: { code: "70", name: "In Transit" },
  OUT_FOR_DELIVERY: { code: "80", name: "Shipment Out For Delivery" },
  NOT_SERVICEABLE: { code: "90", name: "Area For Delivery Is Not Serviceable" },
  DELIVERED: { code: "100", name: "Shipment Delivered" },
  FAILED_DELIVERY: { code: "110", name: "Delivery Failed" },
  CANCELLED_ORDER: { code: "120", name: "Order Has Been Cancelled" },
  RTO_REQUESTED: { code: "130", name: "RTO For Shipment has been Requested" },
  RTO: { code: "140", name: "Marked As Return" },
  RTO_OUT_FOR_DELIVERY: { code: "150", name: "Shipment Is Out For Delivery For RTO" },
  RTO_DELIVERED: { code: "160", name: "RTO Delivered" },
  RTO_FAILED: { code: "170", name: "RTO Failed" },
  LOST: { code: "180", name: "Shipment is Lost" },
  DAMAGED: { code: "190", name: "Shipment is Damaged" },
  SHIPMENT_DELAYED: { code: "200", name: "Shipment Is Delayed Or Misroute" },
  CONTACT_CUSTOMER_CARE: { code: "210", name: "Contact To The Customer Care" },
  SHIPMENT_HELD: { code: "220", name: "Shipment Is Being Held" },
  RTO_INTRANSIT: { code: "230", name: "RTO In Transit" },
  OUT_FOR_PICKUP: { code: "240", name: "Shipment Out For Pickup" },
  RTO_CONTACT_CUSTOMER_CARE: { code: "250", name: "RTO Contact Customer Care" },
  RTO_SHIPMENT_DELAY: { code: "260", name: "RTO Shipment Delayed" },
  AWB_REGISTERED: { code: "270", name: "AWB Registered on Wayuvega" },
  EXCHANGE_PICKUP: { code: "280", name: "Exchange Successful, Shipment Delivered and Picked Up From The Customer" },
  EXCHANGE_INTRANSIT: { code: "290", name: "Exchanged Shipment In Transit to Warehouse" },
  EXCHANGE_DELIVERED: { code: "300", name: "Exchange Shipment Delivered Back" },
  MANIFESTED: { code: "310", name: "When shipment is manifested" },
  ORDER_CANCELLATION_PENDING: { code: "320", name: "Cancellation Pending on Carrier Partner" },
  DESTINATION_HUB_IN: { code: "330", name: "Shipment Reaches The Last Warehouse of Carrier Partner" },
  ORIGIN_CITY_IN: { code: "340", name: "Shipment Reaches The Carrier Partner's First Warehouse After Pickup" },
  ORIGIN_CITY_OUT: { code: "350", name: "Shipment Gets Out of The Carrier Partner's First Warehouse After Pickup" },
  PICKUP_CANCELLED_BY_CARRIER: { code: "360", name: "Pickup Cancelled By Carrier" },
  PICKUP_CANCELLED_BY_SHIPPER: { code: "370", name: "Pickup Cancelled By Shipper" },
  ORDER_CONFIRMATION_AWAITED: { code: "23", name: "Order Confirmation Awaited" },
  ORDER_CONFIRMATION_FAILED: { code: "24", name: "Order Confirmation Failed" },
  ORDER_CONFIRMATION_RECEIVED_FOR_SHIPMENT_PROCESSING: { code: "25", name: "Order Confirmation Received For Shipment Processing" },
  ORDER_CANCELLED_BY_END_CUSTOMER_DURING_CONFIRMATION: { code: "26", name: "Order Cancelled By End Customer During Confirmation" },
  UNKNOWN: { code: "9999", name: "Unknown Status" }
};


// Function to get proper name from code
export const getOrderStatusName = (code) => {
  const status = Object.values(OrderBusinessStatusEnum).find((s) => s.code === String(code));
  return status ? status.name : "Unknown Status";
};

// Reports Name ENUM
export const ReportNameEnum = {
  MIS: { id: 1, name: "MIS" },
};

export const FileProcessingStatus = {
  PENDING_PARSING: "0",
  PARSING: "1",
  PARSING_COMPLETED: "2",
  PARSING_FAILED: "-1",
  SHIPMENT_NOTES_GENERATION_COMPLETED: "3",
  SHIPMENT_NOTES_GENERATION_FAILED: "-2",

  toLabel: (code) => {
    switch (code) {
      case "0": return "Pending Parsing";
      case "1": return "Parsing";
      case "2": return "Parsing Completed";
      case "-1": return "Parsing Failed";
      case "3": return "Notes Generated";
      case "-2": return "Generation Failed";
      default: return "Unknown";
    }
  }
};

export const OrderProcessingStatus = {
  PENDING_VERIFICATION_BY_MERCHANT: "0",
  VERIFIED_BY_MERCHANT: "1",
  VERIFIED_PENDING_AT_WAYUVEGA: "2",
  VERIFIED_SUCCESS_AT_WAYUVEGA: "3",
  VERIFIED_FAILED_AT_WAYUVEGA: "-1",

  toLabel: (code) => {
    switch (code) {
      case "0": return "Pending Verification";
      case "1": return "Verified";
      case "2": return "Pending Processing";
      case "3": return "Order Created";
      case "-1": return "Processing Failed";
      default: return "Unknown";
    }
  }
};

export const FilterField = Object.freeze({
  NONE           : '',
  ORDER_NUMBER   : 'orderNumber',
  BRAND_ID       : 'brandId',
  SHIPMENT_TYPE  : 'shipmentOrderType',
  MARKETPLACE    : 'marketPlaceChannelName',
})

export const FilterFieldLabels = {
  [FilterField.NONE]         : 'No Filter',
  [FilterField.ORDER_NUMBER] : 'Order #',
  [FilterField.BRAND_ID]     : 'Brand ID',
  [FilterField.SHIPMENT_TYPE]: 'Shipment Type',
  [FilterField.MARKETPLACE]  : 'Marketplace',
}

export const CodRemittanceReportStatusEnum = {
  REPORT_GENERATED: { code: "REPORT_GENERATED", name: "Report Generated" },
  OPS_APPROVED: { code: "OPS_APPROVED", name: "Operation Approved" },
  FIN_APPROVED: { code: "FIN_APPROVED", name: "Finance Approved" },
  FINAL_APPROVED: { code: "FINAL_APPROVED", name: "Final Approved" },
  REMITTED: { code: "REMITTED", name: "Remitted" },
};

export const getCodRemittanceReportStatusName = (code) => {
  const status = Object.values(CodRemittanceReportStatusEnum).find(
    (s) => s.code === String(code)
  );
  return status ? status.name : "Unknown Status";
};

// Draft Order Status Enum
export const DraftOrderStatusEnum = {
  DRAFT: { code: "DRAFT", name: "Draft" },
  QUEUED: { code: "QUEUED", name: "Queued" },
  PLACED: { code: "PLACED", name: "Placed" },
  FAILED: { code: "FAILED", name: "Failed" },
  DISCARDED: { code: "DISCARDED", name: "Discarded" },
};

export const getDraftOrderStatusName = (code) => {
  const status = Object.values(DraftOrderStatusEnum).find(
    (s) => s.code === String(code)
  );
  return status ? status.name : "Unknown";
};

// Draft Order Source Enum
export const DraftOrderSourceEnum = {
  UI_PANEL: { code: "UI_PANEL", name: "UI Panel" },
  BULK_UPLOAD: { code: "BULK_UPLOAD", name: "Bulk Upload" },
  SHOPIFY: { code: "SHOPIFY", name: "Shopify" },
  AMAZON: { code: "AMAZON", name: "Amazon" },
  MERCHANT_API: { code: "MERCHANT_API", name: "Merchant API" },
  UNICOMMERCE: { code: "UNICOMMERCE", name: "Unicommerce" },
  OTHER: { code: "OTHER", name: "Other" },
};

export const CancellationReasonEnum = {
  CUSTOMER_REQUEST: "Customer requested cancellation",
  ADDRESS_ISSUE: "Incorrect/insufficient address",
  DUPLICATE_ORDER: "Duplicate order",
  PAYMENT_ISSUE: "Payment issue",
  OUT_OF_STOCK: "Out of stock",
  FRAUD_SUSPECTED: "Suspected fraud",
  OTHER: "Other",
};